// Global Components
import * as React from 'react';
import {
  Navigate,
  useLocation,
} from 'react-router-dom';

// Types
import type {
  $ReducerState,
} from '../../redux';

export type $OwnProps = {
  children: JSX.Element;
};

export type $StateProps = {
  auth: $ReducerState<'auth'>;
};

export type $DispatchProps = unknown;

type $Props = $DispatchProps & $OwnProps & $StateProps;

const AuthRoute = function ({
  auth,
  children,
}: $Props) {
  const location = useLocation();

  if (auth.user === null) {
    return (
      <Navigate
        state={{
          from: location,
        }}
        to={'/login'}
      />
    );
  }

  return children;
};

export default AuthRoute;
